export enum Fit {
  width = 'width',
  height = 'height'
}
